import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import { PassouFalhouEnum } from '../../enums-consultaSeguimento'
import { ConsultaSeguimentoPergunta19Model } from './model-consultaSeguimentoPergunta19'

export function prunePergunta19(value: ConsultaSeguimentoPergunta19Model): ConsultaSeguimentoPergunta19Model {
  const pruned: ConsultaSeguimentoPergunta19Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_19_HEADER: value.PERGUNTA_19_HEADER,
  }

  const isHeaderNao = value.PERGUNTA_19_HEADER === SimNaoEnum.NAO
  const isOlhaBarulhoEstranhoNao = value.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.NAO
  const isOlhaPessoaEstranhaNao = value.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.NAO

  if (isHeaderNao) {
    pruned.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO = value.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO
  }

  if (isHeaderNao && isOlhaBarulhoEstranhoNao) {
    pruned.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA = value.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA
  }

  if (isHeaderNao && isOlhaBarulhoEstranhoNao && isOlhaPessoaEstranhaNao) {
    pruned.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO = value.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO
  }

  return pruned
}

export function conditionToCalculatePergunta19(values: ConsultaSeguimentoPergunta19Model): boolean {
  return (
    values.PERGUNTA_19_HEADER === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.SIM ||
    !isEmpty(values.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO)
  )
}

export function calculateResultadoPergunta19(values: ConsultaSeguimentoPergunta19Model): PassouFalhouEnum {
  if (
    values.PERGUNTA_19_HEADER === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA === SimNaoEnum.SIM ||
    values.PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO === SimNaoEnum.SIM
  ) {
    return PassouFalhouEnum.PASSOU
  }
  return PassouFalhouEnum.FALHOU
}
